var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportUploader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7969 4.32812L22 9.57812C22.4688 10.0469 22.4688 10.75 22 11.1719C21.5781 11.6406 20.875 11.6406 20.4062 11.1719L17.0781 7.84375V19.375C17.0781 20.0312 16.6094 20.5 15.9531 20.5C15.3438 20.5 14.8281 20.0312 14.8281 19.375V7.84375L11.5 11.1719C11.0781 11.6406 10.375 11.6406 9.95312 11.1719C9.48438 10.75 9.48438 10.0469 9.95312 9.57812L15.2031 4.32812C15.625 3.90625 16.3281 3.90625 16.7969 4.32812ZM7.375 5.5H7.75C8.35938 5.5 8.875 6.01562 8.875 6.625C8.875 7.28125 8.35938 7.75 7.75 7.75H7.375C6.71875 7.75 6.25 8.26562 6.25 8.875V24.625C6.25 25.2812 6.71875 25.75 7.375 25.75H24.625C25.2344 25.75 25.75 25.2812 25.75 24.625V8.875C25.75 8.26562 25.2344 7.75 24.625 7.75H24.25C23.5938 7.75 23.125 7.28125 23.125 6.625C23.125 6.01562 23.5938 5.5 24.25 5.5H24.625C26.4531 5.5 28 7.04688 28 8.875V24.625C28 26.5 26.4531 28 24.625 28H7.375C5.5 28 4 26.5 4 24.625V8.875C4 7.04688 5.5 5.5 7.375 5.5Z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportUploader);
export default __webpack_public_path__ + "static/media/report-uploader.360ca1d21421c67b46aaaac16c77d092.svg";
export { ForwardRef as ReactComponent };